import React from 'react';
import { Card, Tabs } from 'antd';
import BillingPeriodFeeItemTab from './components/BillingPeriodFeeItemTab';
import BillFeeSummaryTab from './components/BillFeeSummaryTab';
import OperationLogTab from './components/OperationLogTab';

const SettlementDataMaintenancePage: React.FC = () => {
  return (
    <Card title="结算数据维护">
      <Tabs
        defaultActiveKey="billing-period"
        items={[
          {
            key: 'billing-period',
            label: '账期费用项配置',
            children: <BillingPeriodFeeItemTab />,
          },
          {
            key: 'bill-fee-summary',
            label: '账单费用项汇总',
            children: <BillFeeSummaryTab />,
          },
          {
            key: 'operation-log',
            label: '操作记录',
            children: <OperationLogTab />,
          },
        ]}
      />
    </Card>
  );
};

export default SettlementDataMaintenancePage;
